module.exports = __webpack_public_path__ + "static/img/12.302760d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/sp/12.png
// module id = Ry4d
// module chunks = 0